import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from '../types'

export const isogramBadgeDefinition: BoggleBadgeDefinition = {
  category: 'letters',
  description: 'Play a word of length 6+ with no repeated letters',
  iconId: 'unique',
  id: 'isogram',
  level: 'uncommon',
  lockedReveal: 'reveal',
  name: 'Isogram',
  points: getBoggleBadgePointsForLevel('uncommon'),
}
